export enum ProductStockStatus {
    InStock = 0,
    OutOfStock = 1,
    ManufacturedToOrder = 2
}
